/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from "react";
import { ApplicationEntityType } from "../../constant";

// Searchable text for an AE option: exactly the values FormatCustomAELabel shows in the menu,
// so users can find an AE by anything they see in the dropdown. Keep in sync with the label below.
export const filterCustomAEOption = (
  option: unknown,
  rawInput: string
): boolean => {
  const input = rawInput.trim().toLowerCase();
  if (!input) return true;
  // react-select passes { label, value, data }; data is the option object (with the AE in `ae`).
  const { data } = option as { data?: any };
  const ae = data?.ae ?? data;
  let text = [ae?.name, ae?.title];
  if (ae?.type === ApplicationEntityType.GATEWAY) {
    // Same branching as the secondary line rendered below.
    text = ae?.ip
      ? [ae?.name, ae?.title, ae?.ip, ae?.port]
      : [ae?.name, ae?.gateway?.name, ae?.title, ae?.port];
  }
  return text
    .filter((x) => x !== undefined && x !== null)
    .some((x) => String(x).toLowerCase().includes(input));
};

export const FormatCustomAELabel = (
  option: any,
  { context }: { context: "menu" | "value" }
) => {
  let ae = option;
  if ((option as any)?.ae) {
    ae = (option as any)?.ae;
  }
  const secondaryTextStyle =
    context === "menu"
      ? { fontSize: "smaller", color: "inherit" }
      : { fontSize: "smaller", color: "gray" };
  if (context === "menu") {
    return (
      <div>
        <div>{ae?.name}</div>

        {ae.type === ApplicationEntityType.CLOUD && (
          <div style={secondaryTextStyle}>{ae?.title}</div>
        )}

        {ae.type === ApplicationEntityType.GATEWAY && (
          <div style={secondaryTextStyle}>
            {ae?.ip
              ? `${ae?.title} • ${ae?.ip} • ${ae?.port}`
              : `${ae?.gateway?.name} • ${ae?.title} • ${ae?.port}`}
          </div>
        )}
      </div>
    );
  }
  return <div>{ae?.name}</div>;
};
